import React__default, { useContext } from 'react';
import { __rest, __assign } from '../../_virtual/_tslib.js';
export { BusinessRichCardEvents } from './BusinessEventData/index.js';
export { ConsumerRichCardEvents } from './ConsumerEventData/index.js';
import eventEmitter3 from 'eventemitter3';
export { SharedRichCardEvents } from './SharedEventData/index.js';

var RichCardEventEmitterContext = React__default.createContext(undefined);
var RichCardEventEmitterContextConsumer = RichCardEventEmitterContext.Consumer;

var RichCardEventEmitterContextProvider = function RichCardEventEmitterContextProvider(_a) {
  var children = _a.children;
  var eventEmitter = new eventEmitter3();
  return React__default.createElement(RichCardEventEmitterContext.Provider, {
    value: {
      addListener: function addListener(event, action) {
        eventEmitter.addListener(event.toString(), function (data) {
          action(data);
        });
      },
      emitEvent: function emitEvent(_a) {
        var type = _a.type,
            payload = __rest(_a, ["type"]);

        if (eventEmitter.listenerCount(type) === 0) {
          throw new Error("Rich card event emitted [" + type + "] without valid listener.");
        }

        eventEmitter.emit(type, __assign({
          type: type
        }, payload));
      },
      removeListener: function removeListener(event) {
        eventEmitter.removeListener(event.toString());
      }
    }
  }, children);
};

var useRichCardEventEmitter = function useRichCardEventEmitter() {
  var richCardEventEmitter = useContext(RichCardEventEmitterContext);
  return richCardEventEmitter;
};

export { RichCardEventEmitterContext, RichCardEventEmitterContextConsumer, RichCardEventEmitterContextProvider, useRichCardEventEmitter };
//# sourceMappingURL=index.js.map
